import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogBins } from "../../../repositories/CatalogBinRepository";
import { TableBin } from "../components/TableBin";
import { useCatalogBinContext } from "../context/CatalogBinContext";

type Props = {};
export const CatalogBinPage = (props: Props) => {
  const { actions } = useCatalogBinContext();
  const { binId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const getCatalogBinsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogBins();
    if (resp.ok) {
      const bins = get(resp, "data.tables[0].rows", []);
      actions.setBins(bins);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogBinsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Bins"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableBin
              binId={binId}
              isLoading={isLoading}
              getCatalogBinsFromAPI={getCatalogBinsFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
